import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Alert, Button, Col, ControlLabel, DropdownButton, Form, FormControl, FormGroup, Glyphicon, MenuItem, Modal, Nav, Navbar, NavItem, Row} from 'react-bootstrap'
import {IndexLinkContainer, LinkContainer} from 'react-router-bootstrap'
import * as Acl from "../utils/acl"
import logo from '../resources/images/logo-dogpoint.png'


const defaultChangePassword = {
	email: "",
	password: "",
	password2: "",
	errorSeen: false,
	submitted: false
};

const isValidPassword = (password) => {
	return password && password.length >= 5 && password.search(/[!#$%&? "'_\-@^*]/) >= 0
};

class Header extends Component {

	constructor(props) {
		super(props);

		this.state = {
			search: props && props.params && props.params.search ? props.params.search : '',
			forgottenPassword: false,
			isChangePasswordModalOpen: false,
			changePassword: Object.assign({}, defaultChangePassword),
			isFindPartyModalOpen: false
		};

		this.openModalIfNeeded = this.openModalIfNeeded.bind(this);
		this.handleChangePasswordInputChange = this.handleChangePasswordInputChange.bind(this);
		this.handleChangePasswordSubmit = this.handleChangePasswordSubmit.bind(this);
		this.handleChangePasswordModalDismissClick = this.handleChangePasswordModalDismissClick.bind(this);
		this.handleChangePasswordModalOpenClick = this.handleChangePasswordModalOpenClick.bind(this);
	}

	componentWillMount() {
		this.openModalIfNeeded(this.props)
	}

	componentWillReceiveProps(nextProps) {
		this.openModalIfNeeded(nextProps)
	}

	openModalIfNeeded(props) {
		const {session} = props;
		const {isChangePasswordModalOpen} = this.state;

		if (!isChangePasswordModalOpen && !Acl.isLoggedIn(session) && props.token) {
			this.setState({isChangePasswordModalOpen: true});
		}
	}

	getPasswordValidationState() {
		const res = {state: null, error: null};

		const p = this.state.changePassword.password;
		if (!p && !this.state.changePassword.submitted) {
			return res
		}
		if (!isValidPassword(p)) {
			res.error = 'Heslo nesplňuje výše uvedené podmínky';
			if (!this.state.changePassword.submitted) {
				res.state = 'warning';
			} else {
				res.state = 'error';
			}
		} else {
			res.state = 'success';
		}
		return res;
	}

	getPassword2ValidationState() {
		const res = {state: null, error: null};

		const p = this.state.changePassword.password;
		const p2 = this.state.changePassword.password2;
		if (!this.state.changePassword.submitted) {
			return res
		}
		if (p && p === p2) {
			res.state = 'success';
		} else {
			res.state = 'error';
			res.error = 'Kontrola hesla není shodná'
		}
		return res
	}

	handleChangePasswordInputChange(e) {
		const target = e.target || e;
		let value = target.value;
		const name = target.name;

		const {changePassword} = this.state;
		changePassword[name] = value;
		this.setState({changePassword: changePassword})
	}

	handleChangePasswordSubmit(e) {
		if (e) {
			e.preventDefault()
		}

		const {changePassword} = this.state;
		changePassword.submitted = true;
		let valid = true;
		if (changePassword.password !== changePassword.password2) {
			valid = false
		} else if (!isValidPassword(changePassword.password)) {
			valid = false
		}

		changePassword.errorSeen = false;
		this.setState({changePassword: changePassword});
		if (!valid) {
			return
		}

		this.props.onChangePassword(changePassword.email, changePassword.password, this.props.token).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				this.setState({changePassword: Object.assign({}, defaultChangePassword)});
				this.handleChangePasswordModalDismissClick();
				if (this.props.token) {
					this.props.history('/prihlaseni')
				}
			}
		})
	}

	handleChangePasswordModalDismissClick = e => {
		if (e) {
			e.preventDefault()
		}
		const {changePassword} = this.state;

		this.setState({changePassword: changePassword, isChangePasswordModalOpen: false}, () => {
			if (this.props.token) {
				this.props.history.push('/prihlaseni')
			}
		})
	};

	handleChangePasswordModalOpenClick = e => {
		this.setState({isChangePasswordModalOpen: true})
	};

	renderAlert(error) {
		return <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
			<h4>Chyba</h4>
			<p>{error}</p>
		</Alert>
	}

	renderUser() {
		const {session} = this.props;
		if (session.user && session.user.userId) {
			const fullName = (session.user.firstName ? (session.user.firstName + ' ') : "") + session.user.lastName;
			return <div>
				<Glyphicon glyph="user"/><DropdownButton title={fullName} id="bg-nested-dropdown" noCaret bsStyle="link">
				<LinkContainer to={{pathname: "/uzivatele/" + session.user.userId}}>
					<MenuItem eventKey="1">Profil</MenuItem>
				</LinkContainer>
				<MenuItem eventKey="2" onClick={this.handleChangePasswordModalOpenClick}>Změnit heslo</MenuItem>
				<MenuItem eventKey="3" divider/>
				<MenuItem eventKey="4" onClick={this.props.onLogout}>Odhlásit</MenuItem>
			</DropdownButton>
			</div>
		} else {
			return <div>
				<Button bsStyle="link" onClick={this.handleLoginModalOpenClick}>Přihlásit</Button>
			</div>
		}
	}

	renderChangePasswordModal() {
		const {isChangePasswordModalOpen, changePassword} = this.state;
		const {session, token} = this.props;

		if (!isChangePasswordModalOpen) {
			return null
		}
		const passwordState = this.getPasswordValidationState();
		const password2State = this.getPassword2ValidationState();

		return (
			<Modal onHide={this.handleChangePasswordModalDismissClick} show={true} backdrop={"static"}>
				<Form horizontal onSubmit={this.handleChangePasswordSubmit}>
					<Modal.Header>
						<Modal.Title>{token ? "Vytvoření nebo obnova hesla" : "Změna hesla"}</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<p>Heslo musí být alespoň 5 znaků dlouhé a obsahovat speciální znak (!#$%&?_-@^*).</p>
						{session.error && !changePassword.errorSeen && this.renderAlert(session.error)}
						{!Acl.isLoggedIn(session) && <FormGroup controlId="email">
							<Col componentClass={ControlLabel} sm={3}>
								Email
							</Col>
							<Col sm={7}>
								<FormControl type="email" name="email" value={changePassword.email} onChange={this.handleChangePasswordInputChange}/>
							</Col>
						</FormGroup>}

						<FormGroup controlId="password" validationState={passwordState.state}>
							<Col componentClass={ControlLabel} sm={3}>
								Nové heslo
							</Col>
							<Col sm={7}>
								<FormControl type="password" name="password" value={changePassword.password} onChange={this.handleChangePasswordInputChange}/>
								{passwordState.error ? <span className="help-block">{passwordState.error}</span> : null}
							</Col>
						</FormGroup>

						<FormGroup controlId="password2" validationState={password2State.state}>
							<Col componentClass={ControlLabel} sm={3}>
								Kontrola hesla
							</Col>
							<Col sm={7}>
								<FormControl type="password" name="password2" value={changePassword.password2} onChange={this.handleChangePasswordInputChange}/>
								{password2State.error ? <span className="help-block">{password2State.error}</span> : null}
							</Col>
						</FormGroup>
					</Modal.Body>

					<Modal.Footer>
						<Row>
							<Col sm={12}>
								<Button onClick={this.handleChangePasswordModalDismissClick}>Storno</Button>
								<Button type="submit" onClick={this.handleChangePasswordSubmit} bsStyle="success"><Glyphicon glyph="ok"/> Změnit heslo</Button>
							</Col>
						</Row>
					</Modal.Footer>
				</Form>
			</Modal>
		)
	}

	renderNavigation() {
		const {session} = this.props;
		if (!Acl.isLoggedIn(session)) {
			return null
		}

		return <div>
			<Navbar>
				<Nav className={"hidden-sm hidden-xs"}>
					<LinkContainer to="/" exact={true}>
						<NavItem>Domů</NavItem>
					</LinkContainer>
					<LinkContainer to="/vencitele" exact={true}>
						<NavItem>Osoby</NavItem>
					</LinkContainer>
					<LinkContainer to="/vychazky" exact={true}>
						<NavItem>Vycházky</NavItem>
					</LinkContainer>
					<LinkContainer to="/psi" exact={true}>
						<NavItem>Psi</NavItem>
					</LinkContainer>
					<LinkContainer to="/prijmy" exact={true}>
						<NavItem>Příjmy</NavItem>
					</LinkContainer>
					<LinkContainer to="/ukony" exact={true}>
						<NavItem>Úkony</NavItem>
					</LinkContainer>
					<LinkContainer to="/uzivatele" exact={true}>
						<NavItem>Uživatelé</NavItem>
					</LinkContainer>
				</Nav>
				{Acl.isLoggedIn(session) ? <div className={"navbar-right nav navbar-nav"} id={"caption"}>
					{this.renderUser()}
				</div> : null}
			</Navbar>
		</div>;
	}

	render() {
		const {headerContent} = this.props;

		return (
			<header id="header">
				<IndexLinkContainer to="/">
					<Button bsStyle="link" className="logo">
						<img src={logo} alt="Dogpoint, o.p.s." style={{'verticalAlign': 'top'}}/>
					</Button>
				</IndexLinkContainer>
				{headerContent}
				{this.renderNavigation()}
				{this.renderChangePasswordModal()}
			</header>
		)
	}
}

Header.propTypes = {
	onLogin: PropTypes.func.isRequired,
	onLogout: PropTypes.func.isRequired,
	onChangePassword: PropTypes.func.isRequired,
	onForgottenPassword: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	headerContent: PropTypes.node,
};

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js